import { Link } from 'react-router-dom';
import type { Article } from '@/types/article';
import { formatDate, formatViews } from '@/utils/articles';

interface ArticleCardProps {
  article: Article;
  index?: number;
  rank?: number;
}

export default function ArticleCard({ article, rank }: ArticleCardProps) {
  return (
    <Link
      to={`/detail/${article.id}`}
      className="group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-4"
    >
      <div className="relative h-24 w-32 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-28 md:w-44">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 91黑料网`}
          className="h-full w-full object-top"
        />
        {typeof rank === 'number' && (
          <span
            className={`absolute left-0 top-0 flex h-6 w-6 items-center justify-center font-label text-xs font-bold text-background-50 ${
              rank <= 3 ? 'bg-accent-500' : 'bg-foreground-500'
            }`}
          >
            {rank}
          </span>
        )}
      </div>

      <div className="flex min-w-0 flex-1 flex-col">
        <h3 className="clamp-2 text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {article.title}
        </h3>
        <p className="clamp-2 mt-1.5 hidden text-xs leading-relaxed text-foreground-500 sm:block">
          {article.excerpt}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 pt-2 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-price-tag-3-line"></i>
            {article.category}
          </span>
          <span className="hidden items-center gap-1 sm:flex">
            <i className="ri-newspaper-line"></i>
            {article.source}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {formatDate(article.publishTime).slice(0, 10)}
          </span>
          <span className="ml-auto flex items-center gap-1 text-foreground-500">
            <i className="ri-eye-line"></i>
            {formatViews(article.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}